/*
 * bpmbuild-development.appspot.com
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.11-SNAPSHOT
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/IBuildingV2Response', 'model/ILocationV2Response', 'model/LocationV2Request', 'model/UserBean'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./IBuildingV2Response'), require('./ILocationV2Response'), require('./LocationV2Request'), require('./UserBean'));
  } else {
    // Browser globals (root is window)
    if (!root.BpmbuildDevelopmentappspotcom) {
      root.BpmbuildDevelopmentappspotcom = {};
    }
    root.BpmbuildDevelopmentappspotcom.BuildingV2Response = factory(root.BpmbuildDevelopmentappspotcom.ApiClient, root.BpmbuildDevelopmentappspotcom.IBuildingV2Response, root.BpmbuildDevelopmentappspotcom.ILocationV2Response, root.BpmbuildDevelopmentappspotcom.LocationV2Request, root.BpmbuildDevelopmentappspotcom.UserBean);
  }
}(this, function(ApiClient, IBuildingV2Response, ILocationV2Response, LocationV2Request, UserBean) {
  'use strict';

  /**
   * The BuildingV2Response model module.
   * @module model/BuildingV2Response
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>BuildingV2Response</code>.
   * @alias module:model/BuildingV2Response
   * @class
   */
  var exports = function() {
  };

  /**
   * Constructs a <code>BuildingV2Response</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/BuildingV2Response} obj Optional instance to populate.
   * @return {module:model/BuildingV2Response} The populated <code>BuildingV2Response</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();
      if (data.hasOwnProperty('addressLine1'))
        obj.addressLine1 = ApiClient.convertToType(data['addressLine1'], 'String');
      if (data.hasOwnProperty('addressLine2'))
        obj.addressLine2 = ApiClient.convertToType(data['addressLine2'], 'String');
      if (data.hasOwnProperty('addressLine3'))
        obj.addressLine3 = ApiClient.convertToType(data['addressLine3'], 'String');
      if (data.hasOwnProperty('buildingId'))
        obj.buildingId = ApiClient.convertToType(data['buildingId'], 'String');
      if (data.hasOwnProperty('buildingList'))
        obj.buildingList = ApiClient.convertToType(data['buildingList'], [IBuildingV2Response]);
      if (data.hasOwnProperty('city'))
        obj.city = ApiClient.convertToType(data['city'], 'String');
      if (data.hasOwnProperty('clientId'))
        obj.clientId = ApiClient.convertToType(data['clientId'], 'String');
      if (data.hasOwnProperty('codeTag'))
        obj.codeTag = ApiClient.convertToType(data['codeTag'], 'String');
      if (data.hasOwnProperty('country'))
        obj.country = ApiClient.convertToType(data['country'], 'String');
      if (data.hasOwnProperty('countryCode'))
        obj.countryCode = ApiClient.convertToType(data['countryCode'], 'String');
      if (data.hasOwnProperty('countyState'))
        obj.countyState = ApiClient.convertToType(data['countyState'], 'String');
      if (data.hasOwnProperty('crudlStatus'))
        obj.crudlStatus = ApiClient.convertToType(data['crudlStatus'], 'String');
      if (data.hasOwnProperty('customerId'))
        obj.customerId = ApiClient.convertToType(data['customerId'], 'String');
      if (data.hasOwnProperty('dateCreated'))
        obj.dateCreated = ApiClient.convertToType(data['dateCreated'], 'Date');
      if (data.hasOwnProperty('dateDeleted'))
        obj.dateDeleted = ApiClient.convertToType(data['dateDeleted'], 'Date');
      if (data.hasOwnProperty('description'))
        obj.description = ApiClient.convertToType(data['description'], 'String');
      if (data.hasOwnProperty('email'))
        obj.email = ApiClient.convertToType(data['email'], 'String');
      if (data.hasOwnProperty('errorCode'))
        obj.errorCode = ApiClient.convertToType(data['errorCode'], 'Number');
      if (data.hasOwnProperty('foreman'))
        obj.foreman = ApiClient.convertToType(data['foreman'], 'String');
      if (data.hasOwnProperty('foremanEmail'))
        obj.foremanEmail = ApiClient.convertToType(data['foremanEmail'], 'String');
      if (data.hasOwnProperty('foremanName'))
        obj.foremanName = ApiClient.convertToType(data['foremanName'], 'String');
      if (data.hasOwnProperty('foremanTelephone'))
        obj.foremanTelephone = ApiClient.convertToType(data['foremanTelephone'], 'String');
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('lastUpdatedDateTime'))
        obj.lastUpdatedDateTime = ApiClient.convertToType(data['lastUpdatedDateTime'], 'Date');
      if (data.hasOwnProperty('listQuantitySurveyors'))
        obj.listQuantitySurveyors = ApiClient.convertToType(data['listQuantitySurveyors'], [UserBean]);
      if (data.hasOwnProperty('listSiteManagerIds'))
        obj.listSiteManagerIds = ApiClient.convertToType(data['listSiteManagerIds'], ['String']);
      if (data.hasOwnProperty('locationList'))
        obj.locationList = ApiClient.convertToType(data['locationList'], [ILocationV2Response]);
      if (data.hasOwnProperty('locationRequestList'))
        obj.locationRequestList = ApiClient.convertToType(data['locationRequestList'], [LocationV2Request]);
      if (data.hasOwnProperty('name'))
        obj.name = ApiClient.convertToType(data['name'], 'String');
      if (data.hasOwnProperty('postalZipCode'))
        obj.postalZipCode = ApiClient.convertToType(data['postalZipCode'], 'String');
      if (data.hasOwnProperty('postcode'))
        obj.postcode = ApiClient.convertToType(data['postcode'], 'String');
      if (data.hasOwnProperty('responseMsg'))
        obj.responseMsg = ApiClient.convertToType(data['responseMsg'], 'String');
      if (data.hasOwnProperty('siteId'))
        obj.siteId = ApiClient.convertToType(data['siteId'], 'String');
      if (data.hasOwnProperty('siteManagerId'))
        obj.siteManagerId = ApiClient.convertToType(data['siteManagerId'], 'String');
      if (data.hasOwnProperty('telephone'))
        obj.telephone = ApiClient.convertToType(data['telephone'], 'String');
      if (data.hasOwnProperty('town'))
        obj.town = ApiClient.convertToType(data['town'], 'String');
      if (data.hasOwnProperty('type'))
        obj.type = ApiClient.convertToType(data['type'], 'String');
      if (data.hasOwnProperty('userId'))
        obj.userId = ApiClient.convertToType(data['userId'], 'String');
    }
    return obj;
  }

  /**
   * @member {String} addressLine1
   */
  exports.prototype.addressLine1 = undefined;

  /**
   * @member {String} addressLine2
   */
  exports.prototype.addressLine2 = undefined;

  /**
   * @member {String} addressLine3
   */
  exports.prototype.addressLine3 = undefined;

  /**
   * @member {String} buildingId
   */
  exports.prototype.buildingId = undefined;

  /**
   * @member {Array.<module:model/IBuildingV2Response>} buildingList
   */
  exports.prototype.buildingList = undefined;

  /**
   * @member {String} city
   */
  exports.prototype.city = undefined;

  /**
   * @member {String} clientId
   */
  exports.prototype.clientId = undefined;

  /**
   * @member {String} codeTag
   */
  exports.prototype.codeTag = undefined;

  /**
   * @member {String} country
   */
  exports.prototype.country = undefined;

  /**
   * @member {String} countryCode
   */
  exports.prototype.countryCode = undefined;

  /**
   * @member {String} countyState
   */
  exports.prototype.countyState = undefined;

  /**
   * @member {module:model/BuildingV2Response.CrudlStatusEnum} crudlStatus
   */
  exports.prototype.crudlStatus = undefined;

  /**
   * @member {String} customerId
   */
  exports.prototype.customerId = undefined;

  /**
   * @member {Date} dateCreated
   */
  exports.prototype.dateCreated = undefined;

  /**
   * @member {Date} dateDeleted
   */
  exports.prototype.dateDeleted = undefined;

  /**
   * @member {String} description
   */
  exports.prototype.description = undefined;

  /**
   * @member {String} email
   */
  exports.prototype.email = undefined;

  /**
   * @member {Number} errorCode
   */
  exports.prototype.errorCode = undefined;

  /**
   * @member {String} foreman
   */
  exports.prototype.foreman = undefined;

  /**
   * @member {String} foremanEmail
   */
  exports.prototype.foremanEmail = undefined;

  /**
   * @member {String} foremanName
   */
  exports.prototype.foremanName = undefined;

  /**
   * @member {String} foremanTelephone
   */
  exports.prototype.foremanTelephone = undefined;

  /**
   * @member {String} id
   */
  exports.prototype.id = undefined;

  /**
   * @member {Date} lastUpdatedDateTime
   */
  exports.prototype.lastUpdatedDateTime = undefined;

  /**
   * @member {Array.<module:model/UserBean>} listQuantitySurveyors
   */
  exports.prototype.listQuantitySurveyors = undefined;

  /**
   * @member {Array.<String>} listSiteManagerIds
   */
  exports.prototype.listSiteManagerIds = undefined;

  /**
   * @member {Array.<module:model/ILocationV2Response>} locationList
   */
  exports.prototype.locationList = undefined;

  /**
   * @member {Array.<module:model/LocationV2Request>} locationRequestList
   */
  exports.prototype.locationRequestList = undefined;

  /**
   * @member {String} name
   */
  exports.prototype.name = undefined;

  /**
   * @member {String} postalZipCode
   */
  exports.prototype.postalZipCode = undefined;

  /**
   * @member {String} postcode
   */
  exports.prototype.postcode = undefined;

  /**
   * @member {String} responseMsg
   */
  exports.prototype.responseMsg = undefined;

  /**
   * @member {String} siteId
   */
  exports.prototype.siteId = undefined;

  /**
   * @member {String} siteManagerId
   */
  exports.prototype.siteManagerId = undefined;

  /**
   * @member {String} telephone
   */
  exports.prototype.telephone = undefined;

  /**
   * @member {String} town
   */
  exports.prototype.town = undefined;

  /**
   * @member {String} type
   */
  exports.prototype.type = undefined;

  /**
   * @member {String} userId
   */
  exports.prototype.userId = undefined;


  /**
   * Allowed values for the <code>crudlStatus</code> property.
   * @enum {String}
   * @readonly
   */
  exports.CrudlStatusEnum = {
    /**
     * value: "CREATE"
     * @const
     */
    CREATE: "CREATE",

    /**
     * value: "READ"
     * @const
     */
    READ: "READ",

    /**
     * value: "UPDATE"
     * @const
     */
    UPDATE: "UPDATE",

    /**
     * value: "DELETE"
     * @const
     */
    DELETE: "DELETE",

    /**
     * value: "LIST"
     * @const
     */
    LIST: "LIST"
  };

  return exports;

}));



// WEBPACK FOOTER //
// ./clientLibsDevelopment/src/model/BuildingV2Response.js